import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Sparkles, LogIn, KeyRound } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import api from '@/lib/api';
import { setAuth, isAuthenticated } from '@/lib/auth';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (isAuthenticated()) navigate('/admin'); }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post('/auth/login', { email, password });
      setAuth(res.data.access_token, res.data.user);
      toast.success(`Benvenuto, ${res.data.user?.nome || res.data.user?.email}`);
      navigate('/admin');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Credenziali non valide');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[color:var(--bg)] hero-overlay relative">
      <form onSubmit={submit} className="w-full max-w-md rounded-2xl border border-[color:var(--border-c)] bg-[color:var(--surface)] p-7 relative z-10 shadow-[0_30px_80px_rgba(0,0,0,0.7)]" data-testid="admin-login-form">
        <div className="flex items-center gap-2 mb-2"><Sparkles className="w-4 h-4 text-[color:var(--gold)]"/><span className="text-xs uppercase tracking-[0.3em] text-[color:var(--gold)]">Admin</span></div>
        <h1 className="font-heading text-3xl mb-1">Roma <span className="text-[color:var(--gold)]">Nightlife</span></h1>
        <p className="text-sm text-[color:var(--text-muted)] mb-6">Accedi al pannello di amministrazione</p>
        <div className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-wider text-[color:var(--text-subtle)]">Email</Label>
            <Input data-testid="admin-login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="tuanome@email.com" className="mt-1 bg-[color:var(--surface-2)] border-[color:var(--border-c)]" />
          </div>
          <div>
            <div className="flex items-center justify-between">
              <Label className="text-xs uppercase tracking-wider text-[color:var(--text-subtle)]">Password</Label>
              <Link to="/admin/forgot-password" className="text-xs text-[color:var(--gold)] hover:text-[color:var(--gold-soft)] inline-flex items-center gap-1" data-testid="admin-forgot-password-link"><KeyRound className="w-3 h-3"/>Hai dimenticato la password?</Link>
            </div>
            <Input data-testid="admin-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1 bg-[color:var(--surface-2)] border-[color:var(--border-c)]" />
          </div>
          <Button data-testid="admin-login-submit-button" type="submit" disabled={busy} className="w-full bg-[color:var(--gold-strong)] hover:bg-[#C6A21A] text-black font-semibold btn-press">
            <LogIn className="w-4 h-4 mr-2"/> {busy ? 'Accesso…' : 'Accedi'}
          </Button>
        </div>
        <div className="mt-6 pt-4 border-t border-[color:var(--border-c)] text-center">
          <Link to="/" className="text-xs text-[color:var(--text-subtle)] hover:text-[color:var(--gold)]">← Torna al sito</Link>
        </div>
      </form>
    </div>
  );
}
